const collections = [
  {
    collection: "planies-nft-185421614",
    name: "Planies NFT",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/planies-nft-185421614/image_type_logo/9724ed607d919095e55ae76c972e4a/179724ed607d919095e55ae76c972e4a.png",
    banner_image_url: "",
    owner: "0x84dba4753dfe520980c7637c3038045e2e44cbc4",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/planies-nft-185421614",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",

    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x0d3df518521a84b4cf05a0b68c387c00649c52f7",
        chain: "base",
      },
    ],
  },
  {
    collection: "happines-is-free",
    name: "Happines is free",
    description: "happiness is free",
    image_url:
      "https://i2c.seadn.io/collection/happines-is-free/image_type_logo/9cc440d6cc153c701582c4d8449fef/089cc440d6cc153c701582c4d8449fef.jpeg",
    banner_image_url: "",
    owner: "0x148c6f597e7a68309a2c49e0dd04c7f6ab4ee718",
    safelist_status: "not_requested",
    category: "MEMBERSHIPS",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/happines-is-free",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x0d3df518521a84b4cf05a0b68c387c00649c52f7",
        chain: "base",
      },
    ],
  },
  {
    collection: "ultra-statue-edition",
    name: "Ultra Statue Edition",
    description:
      "Ultra Statue Edition\n\nMade with [NFTs2Me](https://nfts2me.com/)",
    image_url: "",
    banner_image_url: "",
    owner: "0x3b3d96d7ba6d981ed0861e54d6298947b495f68f",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/ultra-statue-edition",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x5f87f7282f4837f7aeffae820aa0ca1c70ee6dea",
        chain: "somnia",
      },
    ],
  },
  {
    collection: "what-the-duck-657539054",
    name: "WHAT THE DUCK",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/what-the-duck-657539054/image_type_logo/75cbd36a95a6f2b242b5eaba282a5a/f675cbd36a95a6f2b242b5eaba282a5a.png",
    banner_image_url: "",
    owner: "0xdef774488530d78e0164ddc4a36e01d1c984a6f5",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/what-the-duck-657539054",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xbfd9cf2214b9b3c2199b4c35ce47e9a4b12a1e9a",
        chain: "base",
      },
    ],
  },
  {
    collection: "crucial1",
    name: "Crucial",
    description:
      "A cosmic explosion of pure energy, captured in the moment in which a spiral of fire and light opens in the void. Crystallized fragments float in space while blue electrical discharges cross the scene, creating a vibrant contrast between chaos and harmony. A work that represents power, rebirth and transformation, designed for those who collect rare and otherworldly visions",
    image_url:
      "https://i2c.seadn.io/collection/vortex-885577090/image_type_logo/780e4b570a39c27e20a80176a33cb0/80780e4b570a39c27e20a80176a33cb0.png",
    banner_image_url: "",
    owner: "0x609e277ed5474f8804bf8444dbe52fb79af3690e",
    safelist_status: "not_requested",
    category: "ART",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/crucial1",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x920faff56462ec54cdfecbe0b8cf75227b3c83f8",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "aries-i",
    name: "Aries I",
    description: "First decan of Aries 21 March 2026 7:19AM Orono, MN",
    image_url:
      "https://i2c.seadn.io/collection/aries-i/image_type_logo/a6d1a0ee13058b08e7b3bcaa59b454/09a6d1a0ee13058b08e7b3bcaa59b454.jpeg",
    banner_image_url: "",
    owner: "0x8d5dd464bbfb7b91f72f452729e0db3c9bab272b",
    safelist_status: "not_requested",
    category: "ART",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/aries-i",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x1e8757901f85ddc0e47d3f686b60e41d90dfb457",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "my-token-419149468",
    name: "My Token",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0xc5b1bb30ed5853069bedbb005ace777cd4fe3c67",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/my-token-419149468",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xfda7228bda2be09b4e87ddd7e176193cbd5b0c2a",
        chain: "base",
      },
    ],
  },
  {
    collection: "moving-block",
    name: "Moving Blocks",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/moving-block/image_type_logo/7a88eb23ce8fbdf292e938664f1567/a97a88eb23ce8fbdf292e938664f1567.png",
    banner_image_url: "",
    owner: "0x84dba4753dfe520980c7637c3038045e2e44cbc4",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/moving-block",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x3e45198db6b7e690690b1c8fd2c3fe50c4c6cedc",
        chain: "base",
      },
    ],
  },
  {
    collection: "paws-handmade-nft",
    name: "PAWS Handmade NFT",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/paws-handmade-nft/image_type_logo/e7737bf58f88fa828469105eee943d/c5e7737bf58f88fa828469105eee943d.jpeg",
    banner_image_url: "",
    owner: "0x2a69ee95dc310c022b01852dfb702c5d462cea60",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/paws-handmade-nft",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xbd63697d6968369bbb342271fbee3906083bf9d6",
        chain: "base",
      },
    ],
  },
  {
    collection: "penguish-kong",
    name: "Penguish Kong",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/penguish-kong/image_type_logo/940a68c59c51576da7ac927ef2fc8b/d7940a68c59c51576da7ac927ef2fc8b.png",
    banner_image_url: "",
    owner: "0xa59ca244d4432df7810f6548bbf6df5e29ed750f",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/penguish-kong",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: "PenguishETH",
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x0400580072371671eaaaa3657d7e87fd7aa521c2",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "nekomons-502558920359",
    name: "NekomOns",
    description:
      "3333 cute cats each cat has a unique skin texture that's made off a 90s & 2000s\nSITCOM, gaming and fashion covers.",
    image_url:
      "https://i2c.seadn.io/collection/nekomons-50255259/image_type_logo/960d44f23e00909f3a48b2612a3202/0a960d44f23e00909f3a48b2612a3202.jpeg",
    banner_image_url: "",
    owner: "0x26a8a392a6d377da049087076cdf62a4b470c5b3",
    safelist_status: "not_requested",
    category: "PFPS",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/nekomons-502558920359",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x423c9c48661308ec38509f71cc249238022d4921",
        chain: "base",
      },
    ],
  },
  {
    collection: "my-new-collection-535484300",
    name: "My New Collection",
    description: "A new collection with its own dedicated smart contract",
    image_url:
      "https://i2c.seadn.io/polygon/72277ffdb21e4e57812257ed932244da/616f6940aef3b2a281bb921ffc2062/99616f6940aef3b2a281bb921ffc2062.png",
    banner_image_url: "",
    owner: "0x25e9adfe54c4d2aeeee8f2d658d0c1feb0658d76",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/my-new-collection-535484300",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xa85553809f29c566c785b3e1e5a46f31d5efc488",
        chain: "polygon",
      },
    ],
  },
  {
    collection: "my-new-collection-357860362",
    name: "My New Collection",
    description: "A new collection with its own dedicated smart contract",
    image_url:
      "https://i2c.seadn.io/polygon/6c06864ae9254b70a2f1d3ce5bb0976f/616f6940aef3b2a281bb921ffc2062/99616f6940aef3b2a281bb921ffc2062.png",
    banner_image_url: "",
    owner: "0x25e9adfe54c4d2aeeee8f2d658d0c1feb0658d76",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/my-new-collection-357860362",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xe68df33c007f43664df3d9f87833e9a40e6f92af",
        chain: "polygon",
      },
    ],
  },
  {
    collection: "deafsanddumbs",
    name: "DeafsAndDumbs",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/deafsanddumbs/image_type_logo/90ee2c20657e1de0ad5111c2f72fb2/4690ee2c20657e1de0ad5111c2f72fb2.jpeg",
    banner_image_url: "",
    owner: "0xb01ba8c354f41dd8d73e21bd1e0b5bc09c6935b3",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/deafsanddumbs",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x924257ecd07ec5935bfb4650e7655c05602e52fc",
        chain: "base",
      },
    ],
  },
  {
    collection: "sunglasses-by-cmai-366177942",
    name: "Sunglasses by cmai",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/sunglasses-by-cmai-366177942/image_type_logo/f8c17681f4dad3da5a670efeaa8b70/4bf8c17681f4dad3da5a670efeaa8b70.jpeg",
    banner_image_url: "",
    owner: "0x8ec4b8f65e5454bec235fbfd92f52307f596ff67",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/sunglasses-by-cmai-366177942",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x13fbf8a2e25bdc3aae5129ea624413b70777e7b2",
        chain: "base",
      },
    ],
  },
  {
    collection: "baseinteractions-959102524",
    name: "BaseInteractions",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0x8c5ef7bfd71c8b10b21365ee9376015202452f8b",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/baseinteractions-959102524",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x8bb331b1d7158a307fbe62383ec5bf589d53a50e",
        chain: "base",
      },
    ],
  },
  {
    collection: "the-iridescent-oracle-genesis-of-the-cyber-zen",
    name: "The Iridescent Oracle: Genesis of the Cyber-Zen",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/the-iridescent-oracle-genesis-of-the-cyber-zen/image_type_logo/aea280e55c6a18c908120e17d5caee/7faea280e55c6a18c908120e17d5caee.png",
    banner_image_url: "",
    owner: "0xbb7cca8635ff9694a75510e33c214c42d77418ee",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url:
      "https://opensea.io/collection/the-iridescent-oracle-genesis-of-the-cyber-zen",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x1edb85e91ff762dd65f284ebdb0b3da5986b6416",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "the-death-of-cash-168637073",
    name: "The Death of Cash by X C 0 P Y",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/the-death-of-cash-168637073/image_type_logo/922b72a6055790e08ba07298779bfb/f5922b72a6055790e08ba07298779bfb.gif",
    banner_image_url: "",
    owner: "0x211c569623c1424217a736a00f24cfc1f1b762e0",
    safelist_status: "not_requested",
    category: "ART",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/the-death-of-cash-168637073",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x138bfaf485ce38210b2690edf2f25b3e5a31cccd",
        chain: "base",
      },
    ],
  },
  {
    collection: "dummiez-190572422",
    name: "Dummiez",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/dummiez-190572422/image_type_logo/8a12428a980f2ef0e1799588215b5f/718a12428a980f2ef0e1799588215b5f.jpeg",
    banner_image_url: "",
    owner: "0x6ea88591eb173b9e49b43268a86491c790a33fe1",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/dummiez-190572422",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x1f39a8c455ca4bafa4cf7f17055bea049e692920",
        chain: "base",
      },
    ],
  },
  {
    collection: "monster-unleash",
    name: "Monster Unleash",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/monster-unleash/image_type_logo/6e38fe036586fd7461011b4ea5a379/566e38fe036586fd7461011b4ea5a379.gif",
    banner_image_url: "",
    owner: "0x520d205e61238d9e87b3249bfc10c9dc5a9fcb88",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/monster-unleash",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x9dc9d0ec46298f9a22569966a8b884d5ef728fcd",
        chain: "base",
      },
    ],
  },
  {
    collection: "0x97f4be241be7877fbb857fc04c34c4b5138b6329",
    name: "0x97f4be241be7877fbb857fc04c34c4b5138b6329",
    description: "",
    image_url:
      "https://i2c.seadn.io/optimism/0x97f4be241be7877fbb857fc04c34c4b5138b6329/a4d17b7cb21319e370a52f030010bc/3ca4d17b7cb21319e370a52f030010bc.gif",
    banner_image_url: "",
    owner: "0x335308a91f7bf3fdc2e00188e5e5b0ad6b3da3f9",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: false,
    opensea_url:
      "https://opensea.io/collection/0x97f4be241be7877fbb857fc04c34c4b5138b6329",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x97f4be241be7877fbb857fc04c34c4b5138b6329",
        chain: "optimism",
      },
    ],
  },
  {
    collection: "pizzamizza-851348022",
    name: "PizzaMizza",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0x98cc1712566b1ca4080ccb381a6d867a7e67e609",
    safelist_status: "not_requested",
    category: "PFPS",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/pizzamizza-851348022",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x01783698d6704d1e15b8f03f5270ee8723866106",
        chain: "base",
      },
    ],
  },
  {
    collection: "zns-badge-743165181",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/soneium/0x1ab0e74956d57daf1392dd933159fbc18801c2bd/8ab8ece5edc28458068857de8091f6/d38ab8ece5edc28458068857de8091f6.jpeg",
    banner_image_url: "",
    owner: "0xc323997be3a2a43a6281dccbf3dcafe10ee56837",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-743165181",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x9094b60cc19a464c4fae670390bbd9c4f4182286",
        chain: "soneium",
      },
    ],
  },
  {
    collection: "pixel-ghost-98464922",
    name: "Pixel Ghost",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/pixel-ghost-98464922/image_type_logo/3cab5607925f7ffca93fa995968fb0/0a3cab5607925f7ffca93fa995968fb0.jpeg",
    banner_image_url: "",
    owner: "0x52bbd4d6aec60019216653f65868fc75d3a18b39",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/pixel-ghost-98464922",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xfe0a7f8be90c3d285e5fcfa0c974dce5aec6602c",
        chain: "base",
      },
    ],
  },
  {
    collection: "kaelen-395476187",
    name: "Kaelen",
    description: "",
    image_url:
      "https://i2c.seadn.io/arbitrum/0xb3a6b1a9992b18b491d466adf5f32eeb6c55d988/b3546f494801613f9807192a8d1b9f/65b3546f494801613f9807192a8d1b9f.png",
    banner_image_url: "",
    owner: "0x6bab7a13acc7d0593285edb997d7e7e04f300f45",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/kaelen-395476187",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xb3a6b1a9992b18b491d466adf5f32eeb6c55d988",
        chain: "arbitrum",
      },
    ],
  },
  {
    collection: "zns-badge-965075084",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/base/0x9e0da7a46cba209c585e1880b0b81285b4c87b84/11c93b46d365b9d6d96ef3c3abeed4/3511c93b46d365b9d6d96ef3c3abeed4.png",
    banner_image_url: "",
    owner: "0xc323997be3a2a43a6281dccbf3dcafe10ee56837",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-965075084",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x5b3077b37e88ab799bfab9971b8f306e4136bd0a",
        chain: "base",
      },
    ],
  },
  {
    collection: "zns-badge-867883901",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/base/0x9e0da7a46cba209c585e1880b0b81285b4c87b84/11c93b46d365b9d6d96ef3c3abeed4/3511c93b46d365b9d6d96ef3c3abeed4.png",
    banner_image_url: "",
    owner: "0x9d5765595a92c560c8759d2a9c375c66123765a5",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-867883901",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x82ef969e4ff2e1144b43d84ceef271b936127840",
        chain: "base",
      },
    ],
  },
  {
    collection: "kxdafdk",
    name: "Kxdafdk",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0xd89498a627ebfb7065eedeedd0b79d0e87472efa",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/kxdafdk",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x4c9e20053c447e16401c25824a716f3aa043c853",
        chain: "base",
      },
    ],
  },
  {
    collection: "rivera-pola",
    name: "Rivera Pola",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0x8c3534d8bba51fa67b954cddd705b844b346c094",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/rivera-pola",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x703e673b7d968f59b6869d00a46a31cb28473d3e",
        chain: "polygon",
      },
    ],
  },
  {
    collection: "meng-meng",
    name: "Daily MOE",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/meng-meng/image_type_logo/af9aa45df9ecb4b7f1f0c0f62c0493/cbaf9aa45df9ecb4b7f1f0c0f62c0493.gif",
    banner_image_url: "",
    owner: "0xf0938f1680ad9d96a5b50267bf1007c47f38af39",
    safelist_status: "not_requested",
    category: "ART",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/meng-meng",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xc0910e9ed1af4f17d741f6ef68a6bf29335ea56a",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "the-x-hour",
    name: "The X Hour ",
    description: "",
    image_url:
      "https://i2c.seadn.io/ethereum/0xac757a0f84e5021dd1d94a6e768dfc1e0ad5643d/59d2e1820660dc83eed7f4190384ea/5b59d2e1820660dc83eed7f4190384ea.jpeg",
    banner_image_url: "",
    owner: "0x906f379a582516ab826974ab806dadadecf3971d",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/the-x-hour",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xac757a0f84e5021dd1d94a6e768dfc1e0ad5643d",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "nekomons-852330727",
    name: "Nekomons",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/nekomons-852330727/image_type_logo/960d44f23e00909f3a48b2612a3202/0a960d44f23e00909f3a48b2612a3202.jpeg",
    banner_image_url: "",
    owner: "0x8797330ac0498a65bc5b5f785d7b967ea49ac661",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/nekomons-852330727",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x4ac22945100cb51c1c212ec4712158e3a55c0a36",
        chain: "base",
      },
    ],
  },
  {
    collection: "protogrid-gif",
    name: "Protogrid Gif",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/protogrid-gif/image_type_logo/749821bb5ea29095f3f4c421925a3b/fc749821bb5ea29095f3f4c421925a3b.png",
    banner_image_url: "",
    owner: "0x1b5f8a7870a66eb4006532a7cb3cf045a09ab197",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/protogrid-gif",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x9b01ddd6fd0badbf543ed838534ac5137559f307",
        chain: "base",
      },
    ],
  },
  {
    collection: "zns-badge-963964829",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/ethereum/0x8d5311d3ae629ff4ddf54c608d3929372fa4582e/b80539a8326c4f13faedb44ae0341c/2bb80539a8326c4f13faedb44ae0341c.png",
    banner_image_url: "",
    owner: "0x9d5765595a92c560c8759d2a9c375c66123765a5",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-963964829",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x27887bf381808b15aea024d7b67650fcb17b6cf0",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "babik-400665485",
    name: "babik",
    description: ".\n\nMade with [NFTs2Me](https://nfts2me.com/)",
    image_url: "",
    banner_image_url: "",
    owner: "0x00912c5c2a6f3423915bd62d963bfa6a17334cb3",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/babik-400665485",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xfd3b64c26bd806561271c1b9d984c4ff9319f508",
        chain: "somnia",
      },
    ],
  },
  {
    collection: "biubiu-premium-939096548",
    name: "BiuBiu Premium",
    description: "",
    image_url:
      "https://raw2.seadn.io/arbitrum/0xfeb30a8ee36d0d51f04cf330676e6e2433d1dace/55bfc7ebd71376c2c473e135c26c27/5055bfc7ebd71376c2c473e135c26c27.svg",
    banner_image_url: "",
    owner: "0xad3c2fab4fa07fbaf964efccfb68067610449a20",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/biubiu-premium-939096548",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xfeb30a8ee36d0d51f04cf330676e6e2433d1dace",
        chain: "arbitrum",
      },
    ],
  },
  {
    collection: "chibi-marble",
    name: "Chibi marble ",
    description:
      "Chibi marble statue in museum hall\n\nMade with [NFTs2Me](https://nfts2me.com/)",
    image_url: "",
    banner_image_url: "",
    owner: "0x697a459c83132615dbdc64bc63514b325f3bb3a2",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/chibi-marble",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x11dd6d7d85ce4b179a2fcbc87fa8b7a68dd284d6",
        chain: "somnia",
      },
    ],
  },
  {
    collection: "zns-badge-490656307",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/megaeth/0x2de7876d825f8c69f3035d2fdecd5486fb24c8e6/7b41e56930a90e4f14312473211383/b47b41e56930a90e4f14312473211383.jpeg",
    banner_image_url: "",
    owner: "0x9d5765595a92c560c8759d2a9c375c66123765a5",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-490656307",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x6eae1bbdb8508812298217a02b7d7255a37b4edd",
        chain: "megaeth",
      },
    ],
  },
  {
    collection: "zns-badge-595440013",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/base/0x9e0da7a46cba209c585e1880b0b81285b4c87b84/11c93b46d365b9d6d96ef3c3abeed4/3511c93b46d365b9d6d96ef3c3abeed4.png",
    banner_image_url: "",
    owner: "0x746bfefcbcaa164966f9d6992686c17be438cedb",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-595440013",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x46d8b7c4c947a3bbe1b896ea29c7e1c5a41bc8db",
        chain: "base",
      },
    ],
  },
  {
    collection: "monadagentpassport",
    name: "MonadAgentPassport",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0x296af231ce0262bf49fb27663f8ebcf61135a58c",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/monadagentpassport",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xd3584978b1ad8544d00238f056ccdf0ed59ca9ba",
        chain: "monad",
      },
    ],
  },
  {
    collection: "zns-badge-774898173",
    name: "ZNS Badge",
    description: "",
    image_url:
      "https://i2c.seadn.io/base/0x9e0da7a46cba209c585e1880b0b81285b4c87b84/11c93b46d365b9d6d96ef3c3abeed4/3511c93b46d365b9d6d96ef3c3abeed4.png",
    banner_image_url: "",
    owner: "0x88dd10a5bcecba71f2493cb261b181f57943040d",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/zns-badge-774898173",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x8c555d3ced32fe198c2940346150e92615b44ea9",
        chain: "base",
      },
    ],
  },
  {
    collection: "ltfrs-testnest",
    name: "LTFRS Testnest",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/ltfrs-testnest/image_type_logo/b9e8efd993a3855ef95856209f93eb/32b9e8efd993a3855ef95856209f93eb.png",
    banner_image_url: "",
    owner: "0xfc34b38834313b7974e6d68e42c5b8da9a2bb777",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/ltfrs-testnest",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x5e4a4dca887cc960bf7588db5edf57ba2a15c3bc",
        chain: "base",
      },
    ],
  },
  {
    collection: "echoes-of-time-742427139",
    name: "Echoes of Time",
    description: "",
    image_url:
      "https://i2c.seadn.io/base/0xb864a0531399e8e798f971a1f1d1613098937049/eb4791567b2c6aece95bb0a063705c/8feb4791567b2c6aece95bb0a063705c.png",
    banner_image_url: "",
    owner: "0x5d7247d235abe45ac16d304a7955fd66697cbc3f",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/echoes-of-time-742427139",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xb864a0531399e8e798f971a1f1d1613098937049",
        chain: "base",
      },
    ],
  },
  {
    collection: "demon-girl",
    name: "Demon Girl",
    description:
      "largest JPG file\n\nMade with [NFTs2Me](https://nfts2me.com/)",
    image_url:
      "https://raw2.seadn.io/somnia/fb0d9e6b19de433287820b28ee37d0ad/308c2a5e928c9a1e63b5d36d137e11/c0308c2a5e928c9a1e63b5d36d137e11.mp4",
    banner_image_url:
      "https://i2c.seadn.io/somnia/fb0d9e6b19de433287820b28ee37d0ad/2405d91025d13f59776919f71951ed/762405d91025d13f59776919f71951ed.jpeg",
    owner: "0xe63948434cd4a8161e140a007b1a3ce6eccc1349",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/demon-girl",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xc1f284ef82cdc8d5296cd9637d4d6fd0b02329b6",
        chain: "somnia",
      },
    ],
  },
  {
    collection: "0x7a4bbc2125c831faeb8026b7f04cef53a6eb30ae",
    name: "0x7a4bbc2125c831faeb8026b7f04cef53a6eb30ae",
    description: "",
    image_url:
      "https://i2c.seadn.io/ethereum/0x7a4bbc2125c831faeb8026b7f04cef53a6eb30ae/d5e1aaf2220f99353829fd9127687f/56d5e1aaf2220f99353829fd9127687f.png",
    banner_image_url: "",
    owner: "0xb72993ebb94dc20e4140afc99a4bc5e42d3d93b2",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url:
      "https://opensea.io/collection/0x7a4bbc2125c831faeb8026b7f04cef53a6eb30ae",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x7a4bbc2125c831faeb8026b7f04cef53a6eb30ae",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "0x2f13978405fd9aa8d3cd12a089bc985428a39ef2",
    name: "0x2f13978405fd9aa8d3cd12a089bc985428a39ef2",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0x2e4128e05f1c27b0ce15df60a513528d6485babe",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url:
      "https://opensea.io/collection/0x2f13978405fd9aa8d3cd12a089bc985428a39ef2",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x2f13978405fd9aa8d3cd12a089bc985428a39ef2",
        chain: "ethereum",
      },
    ],
  },
  {
    collection: "string-modelized",
    name: "String Modelized",
    description: "STRING MODELIZED 3D AND PIXEL MODEL COME",
    image_url:
      "https://i2c.seadn.io/collection/string-modelized/image_type_logo/f6e5ad1e02de433072bfcefafa0fc1/a3f6e5ad1e02de433072bfcefafa0fc1.jpeg",
    banner_image_url: "",
    owner: "0x0817d08d6517cf8ac2266046e793a569e695a5be",
    safelist_status: "not_requested",
    category: "PFPS",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/string-modelized",
    project_url: "https://opensea.io/collection/string-modelized",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xeb3642386be62c5b667feab09af67ee3e691df8d",
        chain: "base",
      },
    ],
  },
  {
    collection: "iso-crates-340471686",
    name: "ISO CRATES",
    description: "",
    image_url:
      "https://i2c.seadn.io/collection/iso-crates-340471686/image_type_logo/8e309fa60261c4a5d60902805aa5d0/aa8e309fa60261c4a5d60902805aa5d0.png",
    banner_image_url: "",
    owner: "0x6b79044e73d97537cf03524c493ac9c05c6a65a3",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/iso-crates-340471686",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0x2f0ea1fd55bed1014c0e6063a873793fef27d946",
        chain: "base",
      },
    ],
  },
  {
    collection: "digital-proof-ledger-537492186",
    name: "Digital Proof Ledger",
    description: "",
    image_url: "",
    banner_image_url: "",
    owner: "0xa5c5693dc94852d70465b7a2dbacfba2cd556130",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/digital-proof-ledger-537492186",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xab9a793aca0c391ef359ee725b5cfa7f3b698617",
        chain: "base",
      },
    ],
  },
  {
    collection: "art-820553750",
    name: "art",
    description: "somi art\n\nMade with [NFTs2Me](https://nfts2me.com/)",
    image_url: "",
    banner_image_url: "",
    owner: "0x74bf7a1829acbb487d205c0a247c2b5717b0d0fe",
    safelist_status: "not_requested",
    category: "",
    is_disabled: false,
    is_nsfw: false,
    trait_offers_enabled: false,
    collection_offers_enabled: true,
    opensea_url: "https://opensea.io/collection/art-820553750",
    project_url: "",
    wiki_url: "",
    telegram_url: "",
    discord_url: "",
    twitter_username: null,
    instagram_username: "",
    discord_url: "",
    stats: {
      market_cap: 9.74,
      num_owners: 1103,
      floor_price: 0.0063,
      floor_price_symbol: "ETH",
      total_minted: 1103,
      total_supply: null,
      total_volume: 79.59635878000057,
      one_day_volume: 0,
      seven_day_volume: 0.004,
      thirty_day_volume: 0.009000000000000001,
      one_day_volume_change: 0,
      seven_day_volume_change: 1,
      thirty_day_volume_change: 3,
      total_sales: 2643,
      one_day_sales: 0,
      seven_day_sales: 2,
      thirty_day_sales: 3,
      total_average_price: 0.03011591327279628,
      one_day_average_price: 0,
      seven_day_average_price: 0.002,
      thirty_day_average_price: 0.003,
    },
    contracts: [
      {
        contract_address: "0xa9dbe9561d4095e3efef760971f450d993ad34a8",
        chain: "somnia",
      },
    ],
  },
].map((l) => ({
  ...l,
  key: l.collection,
  banner_image_url: l.banner_image_url ?? "",
  exchange: "opensea",
  exchange_url: "",
  external_url: "",
  banner_image_url: null,
  featured_image_url: null,
  large_image_url: null,
}));

export default collections;
